import { createFileRoute } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";
import { Button } from "@heroui/react";
import { AutoContainer } from "@/components/layout/auto-container";

/**
  404页面，页面未找到时显示的页面
*/

export const Route = createFileRoute("/$")({
  component: NotFoundPage,
});


export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <AutoContainer showHeader={false}>
      <div
        className={
          "mt-4 flex items-center justify-center space-y-4 rounded-none border-0 px-4 pb-4 lg:m-8 lg:mx-8 lg:rounded-xl lg:border lg:px-8 lg:pb-8 lg:pt-8"
        }
      >
        <div
          className={
            "flex w-full flex-col items-center space-y-8 justify-self-center py-4 lg:w-1/2"
          }
        >
          <img className={"mx-auto w-32 mt-24"} src={"/icons/ic-browser-404.svg"} alt={"404"} />

          <div className={"text-2xl font-bold"}>哎呀！你进入了一个荒芜之地</div>

          <div className={"text-gray-700"}>
            请返回再试一次，如果问题依然存在，请联系我们～
          </div>

          <Button className={"w-48"} onPress={() => navigate({ to: "/help" })}>
            前往帮助中心
          </Button>
        </div>
      </div>
    </AutoContainer>
  );
}
